// 货物运输
export default [{
  path: 'bidFreightageAdd',
  name: 'bidFreightageAdd',
  component: function component() {
    return import('@/views/freightageManage/bidFreightage/add');
  }
}, {
  path: 'bidFreightageUpdate',
  name: 'bidFreightageUpdate',
  component: function component() {
    return import('@/views/freightageManage/bidFreightage/update');
  }
}, {
  path: 'reviewFreightageList',
  name: 'reviewFreightageList',
  component: function component() {
    return import('@/views/freightageManage/reviewFreightage/index');
  }
}, {
  path: 'reviewFreightageDetail',
  name: 'reviewFreightageDetail',
  component: function component() {
    return import('@/views/freightageManage/reviewFreightage/detail');
  }
}, {
  path: 'bidFreightageList',
  name: 'bidFreightageList',
  component: function component() {
    return import('@/views/freightageManage/bidFreightage/index');
  }
}, {
  path: 'bidFreightageDetail',
  name: 'bidFreightageDetail',
  component: function component() {
    return import('@/views/freightageManage/bidFreightage/detail');
  }
}, {
  path: 'bidFreightageSuccess',
  name: 'bidFreightageSuccess',
  component: function component() {
    return import('@/views/freightageManage/bidFreightage/success');
  }
}, {
  path: 'reviewFreightageSuccess',
  name: 'reviewFreightageSuccess',
  component: function component() {
    return import('@/views/freightageManage/reviewFreightage/success');
  }
}, {
  path: 'freightageExamination',
  name: 'freightageExamination',
  component: function component() {
    return import('@/views/freightageManage/examination/index');
  }
}, {
  path: 'freightageSupplier',
  name: 'freightageSupplier',
  component: function component() {
    return import('@/views/freightageManage/supplier/index');
  }
}, {
  path: 'freightageExaminationDetail',
  name: 'freightageExaminationDetail',
  component: function component() {
    return import('@/views/freightageManage/examination/detail');
  }
}, {
  path: 'freightageSupplierDetail',
  name: 'freightageSupplierDetail',
  component: function component() {
    return import('@/views/freightageManage/supplier/detail');
  }
}, {
  path: 'freightageSupplierEvaluateDetail',
  name: 'freightageSupplierEvaluateDetail',
  component: function component() {
    return import('@/views/freightageManage/supplier/evaluation');
  }
}];